import { isActiveSubscription, isFeatureEnabled } from 'ff/common/system';

export const isLb4lMode = () => {
    return isFeatureEnabled('logbook_for_life') && !isActiveSubscription();
};

export const buyForeFlightUrl = `${window.purchaseHost}/buy`;
